/**
 * Basic page context for the AI Chat Panel (M22.4).
 *
 * Every chat message carries `current_url` + `current_entity_id` so
 * the assistant can ground itself ("you're on Ahmed's page", "you're
 * looking at the Loans module"). This is the CHEAP context — just
 * the route. Rich context (selected element, visible filters,
 * hovered cell) is M25's `chat-context-rich.ts`.
 */

const _UUID_RE = /^[0-9a-fA-F]{8}-?[0-9a-fA-F]{4}-?[0-9a-fA-F]{4}-?[0-9a-fA-F]{4}-?[0-9a-fA-F]{12}$/;

export interface ChatPageContext {
  current_url: string;
  current_entity_id: string | null;
}

/**
 * Capture the current route + (when on a detail page) the entity id
 * from the last URL segment.
 */
export function captureChatContext(): ChatPageContext {
  const path =
    typeof window !== "undefined"
      ? window.location.pathname
      : "/";
  const segments = path.split("/").filter(Boolean);
  const last = segments[segments.length - 1] ?? "";
  return {
    current_url: path,
    current_entity_id: _UUID_RE.test(last) ? last : null,
  };
}
